import type { CompatibilityListingInput } from "@wags/matchmaker/pure.ts";
import type { CollectionWagsListing } from "./wags-listings";

export function compatibilityInputFromWagsListing(
    listing: Pick<
        CollectionWagsListing,
        | "name"
        | "description"
        | "organization"
        | "isGoodWithKids"
        | "isGoodWithDogs"
        | "isGoodWithCats"
    >,
): CompatibilityListingInput {
    return {
        name: listing.name,
        description: listing.description,
        organizationName: listing.organization?.name ?? null,
        organizationDescription: listing.organization?.description ?? null,
        organizationState: listing.organization?.state ?? null,
        isGoodWithKids: listing.isGoodWithKids,
        isGoodWithDogs: listing.isGoodWithDogs,
        isGoodWithCats: listing.isGoodWithCats,
    };
}
